import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from './Firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

const PrivateRoute = ({ children }) => {
    const [user, loading] = useAuthState(auth);
    if (loading) {
        return <div>Loading...</div>;
    }
    if (!user) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
